<template>
  <div class="vipCardScan">
    <el-dialog
      title="扫描"
      :visible.sync="visible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="close">
      <div class="content">
        <div class="tips">请扫描顾客至尊卡</div>
        <img class="vipCard_img" :src="imgArr.vipCard" />
        <el-button class="vipCard_cannel" @click="close">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { imgArr } from '@/assets/images/img'

  export default {
    name: 'VipCardScan',
    data () {
      return {
        visible: false,
        imgArr: imgArr,
        vipCardNumber: ''
      }
    },
    beforeDestroy() {
      window.onkeydown = null
    },
    methods: {
      open() {
        this.visible = true
        this.vipCardNumber = ''
        this.$nextTick(() => {
          this.keyDownFn()
        })
      },
      close() {
        window.onkeydown = null
        this.visible = false
      },
      keyDownFn() {
        window.onkeydown = e => {
          if (e.keyCode === 16) {
            return
          }
          if (e.keyCode === 13) {
            e.preventDefault()
            this.scanCard()
            return
          }
          this.vipCardNumber = this.vipCardNumber + e.key
        }
      },
      scanCard () {
        this.close()
        this.$emit('scanSuccess', this.vipCardNumber)
      }
    }
  }
</script>

<style lang="less" scoped>
  .vipCardScan {
    overflow: hidden;
  }

  .vipCardScan /deep/ .el-dialog__header {
    padding: 12px 24px;
    border-bottom: 1px solid #E0E0E0 !important;
  }

  .vipCardScan /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }
  
  .vipCardScan /deep/ .el-dialog__body {
    padding: 0;
  }

  .vipCardScan /deep/ .el-dialog__footer {
    padding: 12px 20px;
  }

  .content {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 20px;
    width: 100%;
  }

  .tips {
    line-height: 20px;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
  }

  .vipCard_img {
    margin: 24px 0 0 0;
    width: 170px;
    height: 135px;
  }

  .vipCard_cannel {
    margin: 32px 0 0 0;
    width: 116px;
    height: 32px;
  }

  .vipCard_input {
    position: absolute;
    top: -9999px;
    left: -9999px;
    opacity: 0;
  }
</style>